<mat-vertical-stepper orientation="vertical" (selectionChange)="stepSelectionChange($event, stepper)" linear #stepper>
  <ng-template matStepperIcon="edit" let-index="index">
    {{ index + 1 }}
  </ng-template>
  <ng-template matStepperIcon="done" let-index="index">
    {{ index + 1 }}
  </ng-template>
  <div>
    <mat-step>
      <dx-validation-group #vg0 (onInitialized)="registerGroup(0, vg0)">
        <ng-template matStepLabel>{{ res.get('AddTicketDetails') }}</ng-template>
        <div fxLayout="column" fxLayoutGap="4px" style="margin-top: 7px">
          <div fxLayout="row" fxLayoutGap="4px">
            <abc-text-box
              #ticketDesignation
              class="borderRadius"
              [label]="res.get('TicketDesignation')"
              [labelMode]="'floating'"
              [width]="'100%'"
              [height]="'40px'"
              [(value)]="ticketCreationData.Bezeichnung"
              valueChangeEvent="keyup"
            >
              <dx-validator>
                <dxi-validator-validation-rule
                  type="required"
                  [message]="res.get('TicketDesignationValidationText')"
                ></dxi-validator-validation-rule>
              </dx-validator>
            </abc-text-box>
          </div>
          <div fxLayout="row" fxLayoutGap="4px">
            <abc-drop-down-box
              #ticketDepartmentDropDown
              class="borderRadius"
              [label]="res.get('TicketDepartment')"
              [labelMode]="'floating'"
              [width]="'50%'"
              [height]="'40px'"
              [(value)]="ticketCreationData.Kategorie"
              [showClearButton]="true"
              [dataSource]="kategorieListDatasource"
              valueExpr="value"
              displayExpr="description"
              [gridColumns]="[
                { dataField: 'value', caption: '', width: '30px' },
                { dataField: 'description', caption: '' },
              ]"
            ></abc-drop-down-box>
            <abc-drop-down-box
              #ticketPriorityDropDown
              class="borderRadius"
              [label]="res.get('TicketPriority')"
              [labelMode]="'floating'"
              [width]="'50%'"
              [height]="'40px'"
              [(value)]="ticketCreationData.Dringlichkeit"
              [showClearButton]="true"
              [dataSource]="dringlichkeitListDataSource"
              valueExpr="value"
              displayExpr="description"
              [gridColumns]="[
                { dataField: 'value', width: '30px' },
                { dataField: 'description', caption: '' },
              ]"
            ></abc-drop-down-box>
          </div>
          <div fxLayout="row">
            <abc-text-area
              #ticketDescription
              class="textAreaBorderRadius"
              [label]="res.get('TicketDescription')"
              [labelMode]="'floating'"
              [width]="'100%'"
              [height]="'100px'"
              [value]="''"
              (onValueChanged)="this.ticketCreationData.Beschreibung = $event.value"
              valueChangeEvent="keyup"
            >
            </abc-text-area>
          </div>
        </div>
        <div fxLayout=" row" style="float: right; margin-top: 7px">
          <div fxFlex="30">
            <button mat-button (click)="vg0.instance.validate().isValid && stepper.next()">
              {{ res.get('ButtonTextContinue') }}
            </button>
          </div>
        </div>
      </dx-validation-group>
    </mat-step>
    <mat-step>
      <ng-template matStepLabel>{{ res.get('StepTitleMedia') }}</ng-template>
      <div fxLayout="row" style="margin-top: 10px">
        <abc-media-gallery (onDataChanged)="mediaGalleryDataChanged($event)"> </abc-media-gallery>
      </div>
      <div class="step-buttons">
        <button mat-button class="back-button" matStepperPrevious>
          {{ res.get('ButtonTextBack') }}
        </button>
        <button mat-button matStepperNext>
          {{ res.get('ButtonTextContinue') }}
        </button>
      </div>
    </mat-step>
    <mat-step>
      <ng-template matStepLabel>{{ res.get('StepTitleAssignResourceForPush') }}</ng-template>
      <div fxLayout="row" style="margin-top: 10px">
        <abc-check-box [text]="res.get('AssignResourceForPush')" [(value)]="assignResourceForPush"></abc-check-box>
      </div>
      <div style="margin-top: 10px">
        <dx-validation-group #vg2 (onInitialized)="registerGroup(2, vg2)">
          <abc-select-box
            [label]="res.get('ResourceForPush')"
            [labelMode]="'floating'"
            [stylingMode]="'filled'"
            [focusStateEnabled]="false"
            [dataSource]="personnelResourcesDataSource"
            [(value)]="assignedResourceIdForPush"
            [disabled]="!assignResourceForPush"
            displayExpr="description"
            valueExpr="value"
          >
            <dx-validator>
              <dxi-validator-validation-rule type="required"></dxi-validator-validation-rule>
            </dx-validator>
          </abc-select-box>
        </dx-validation-group>
      </div>
      <div class="step-buttons">
        <button mat-button class="back-button" matStepperPrevious>
          {{ res.get('ButtonTextBack') }}
        </button>
        <button mat-button (click)="vg2.instance.validate().isValid && stepper.next()">
          {{ res.get('ButtonTextContinue') }}
        </button>
      </div>
    </mat-step>
    <mat-step>
      <ng-template matStepLabel>{{ res.get('StepperTextTicketGeneration') }}</ng-template>
      <div class="ticketGenerationText">
        <p>{{ res.get('StepperTextTicketCanBeGenerated') }}</p>
      </div>
      <hr />
      <div class="step-buttons">
        @if (isGenerating) {
          <dx-load-indicator id="small-indicator" height="20" width="20"></dx-load-indicator>
        }
        <button mat-button class="back-button" [disabled]="isGenerating" matStepperPrevious>
          {{ res.get('ButtonTextBack') }}
        </button>
        <button mat-button (click)="generateTicket()" [disabled]="isGenerating">
          <span>
            {{ res.get('ButtonTextStartExecution') }}
          </span>
        </button>
      </div>
    </mat-step>
  </div>
</mat-vertical-stepper>
